import { IMarketingInfo } from "../../../models"

export interface IAccountRegistraionDTO {
    AccountName: string
    Email: string
    FirstName: string
    LastName: string
    CompanyType: ETypeOfBusiness
    CompanySize: ESizeOfBusiness
    SendWelcomeEmail: boolean
    DefaultIANATimezoneId: string
    RecaptchaResponse: string
    MarketingInfo: IMarketingInfo
    RegistByAccountManager: boolean
    PhoneNumber: string
}

export enum ESizeOfBusiness {
    ZeroTo10 = 0,
    TenTo50 = 1,
    FiftyTo250 = 2,
    TwoFiftyTo500 = 3,
    FiveHundredTo1500 = 4,
    FifteenHundredPlus = 5,
    GreaterThan10000 = 6
}

export enum ETypeOfBusiness {
    BuildingServicesAndMaintanence = 1,
    Construction = 2,
    HealthCare = 3,
    Janitorial = 4,
    Manufacturing = 5,
    Security = 6,
    TempStaffing = 7,
    Other = 8
}